import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import "./PdfPage.css";
import NoData from "./NoData";
import ChartLoader from "./ChartLoader";

const chunkArray = (array, chunkSize) => {
  const result = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }

  return result;
};

const calculateNewStartDate = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const timeDiff = end - start;
  const daysDiff = timeDiff / (1000 * 3600 * 24);

  if (daysDiff > 31) {
    const newStart = new Date(end);
    newStart.setDate(newStart.getDate() - 30);
    return newStart.toISOString();
  }

  return startDate;
};

// export default function CriticalTableLastPage(props) {
const CriticalTableLastPage = forwardRef((props, ref) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let { title, template_id, show, soarting, gloablfilter, IND } = props;

  const [refreshDate, setRefreshDate] = useState("");
  const [topThreeVin, setTopThreeVin] = useState([]);
  const tableRefs = useRef([]);

  useEffect(() => {
    const newStartDate = calculateNewStartDate(
      gloablfilter.startDate,
      gloablfilter.endDate
    );
    const updatedFilterData = { ...gloablfilter, startDate: newStartDate };

    fetchData(
      {
        url: API_URL_MAIN + "pdf_bus/critical_table",
        body: { filterdata: updatedFilterData, vin: props.topThreeVin },
      },
      appyData
    );
  }, [gloablfilter, props.topThreeVin]);

  const appyData = (data) => {
    setTopThreeVin(data);
    // console.log("data", data);
  };

  const chunks2 = chunkArray(topThreeVin, 15);
  // console.log("chunks2", chunks2);

  useImperativeHandle(ref, () => ({
    getDataForSlide: () => ({
      chunks2,
      tableRefs,
      topThreeVin,
    }),
  }));

  return (
    <div className="criticaltablepage">
      <div className="row" style={{ justifyContent: "end" }}>
        <img
          src="../../../assets/img_Bus/Pdf_Page/Tatamotors.png"
          alt=""
          style={{ height: "80px", width: "250px" }}
        />
      </div>
      <div
        className="row mt-4"
        style={{
          color: "#002060",
          paddingLeft: "60px",
          fontSize: "16px",
          fontWeight: "bolder",
        }}
      >
        Details of Vehicles with Highest Operating Temp.
      </div>

      <div className="row">
        <div className="col-md-1"></div>
        <div
          className="col-md-10"
          style={{ paddingLeft: "80px", paddingRight: "10px" }}
        >
          {isLoading ? (
            <ChartLoader />
          ) : topThreeVin.length > 0 ? (
            chunks2.map((chunk, chunkIndex) => (
              <div
                key={chunkIndex}
                // ref={tableRefs}
                id={`${chunkIndex + 1}st__div_formed`}
                className={`pdf-page ${
                  chunkIndex === 0 ? "" : "pdf-page-extra-padding"
                }`}
              >
                <div>
                  <table
                    className="table criticaltable"
                    ref={(el) => (tableRefs.current[chunkIndex] = el)}
                    // id={`${chunkIndex + 1}${props.topThreeVin}`}
                    // id={`${chunkIndex + 1}st__table_formed`}
                    id={`${chunkIndex + 1}-vin-${
                      props.criticalTableLastPageId + 1
                    }`}
                    // id={`${props?.criticalTableLastPageId}-table-${chunkIndex+1}`}
                    style={{ color: "black", font: "12px", fontSize: "medium" }}
                  >
                    <thead className="criticaltable">
                      <tr
                        style={{
                          backgroundColor: "#44546a",
                          color: "#fff",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <th colSpan="7">{props.topThreeVin}</th>
                      </tr>
                      <tr style={{ backgroundColor: "#44546a", color: "#fff" }}>
                        <th>Date</th>
                        <th>A_Max_Cell_Temp Per Day</th>
                        <th>B_Max_Cell_Temp Per Day</th>
                        <th>C_Max_Cell_Temp Per Day</th>
                        <th>D_Max_Cell_Temp Per Day</th>
                        <th>Max_Temp_Diff Per Day</th>
                        <th>Max_Temp Pack</th>
                      </tr>
                    </thead>
                    <tbody>
                      {chunk.map((item, index) => (
                        <tr key={index}>
                          <td>{item._source.eventdate}</td>
                          <td>
                            {item._source.A_Max_Cell_Temp
                              ? item._source.A_Max_Cell_Temp
                              : "-"}
                          </td>
                          <td>
                            {item._source.B_Max_Cell_Temp
                              ? item._source.B_Max_Cell_Temp
                              : "-"}
                          </td>
                          <td>
                            {item._source.C_Max_Cell_Temp
                              ? item._source.C_Max_Cell_Temp
                              : "-"}
                          </td>
                          <td>
                            {item._source.D_Max_Cell_Temp
                              ? item._source.D_Max_Cell_Temp
                              : "-"}
                          </td>
                          <td>{item._source.greatest_value}</td>
                          <td>{item._source.greatest_columns}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="footer">
                  <div className="row sixthbottomcontentnew">
                    <div className="col-md-3">
                      <img
                        src="../../../assets/img_Bus/Pdf_Page/footer.png"
                        alt=""
                        style={{ height: "70px", width: "200px" }}
                      />
                    </div>
                    <div className="col-md-1"></div>
                    <div className="col-md-5">
                      <p
                        style={{
                          fontSize: "11px",
                          paddingTop: "60px",
                          paddingLeft: "10px",
                        }}
                      >
                        Copyright, Confidential, Tata Motors Limited
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div id={`no-data-critical`}>
              <NoData />
            </div>
          )}
        </div>
      </div>
    </div>
  );
});

export default CriticalTableLastPage;
